const gameCreationSuggestions = [
	{
		path: '/community/games/creation-suggestions',
		name: 'community-game-creation-suggestions-list',
		component: () => import('@/views/community/game-creation-suggestions/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,moderation',
		},
	},
]

export default gameCreationSuggestions
